export const REPORTS_BG =
  'https://static.solartrip.com/images/reports_landing/reports_coin_bg.webp';
